import React, { useState } from 'react';

import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import PersonIcon from "@material-ui/icons/Person";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

import { Button,Modal, Row, Col,Container  } from 'react-bootstrap';

import CustomBtn from "./CustomBtn"

function MydModalWithGrid(props) {

  const handleClose = () => {
    props.handle(false)
  }

  return (
    <Modal 
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={props.show}
      onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
        {props.talent.fullname}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="show-grid">
        <Container>
          <Row>
            <Col xs={12} md={8}>
              <div >
              <Button>Connect</Button>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={8} md={6}>
            <p>{props.talent.resume.features}</p>
            </Col>
            <Col xs={4} md={6}>
              <h1>Experience</h1>
              <h5>Education</h5>
              <p>empty</p>
            </Col>
          </Row>
          <Row>
            <Col xs={6} md={4}>
            </Col>
            <Col xs={6} md={4}>
            </Col>
            <Col xs={6} md={4}>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 250,
    borderRadius: 25,
    boxShadow: '2px 2px 5px grey',
    maxHeight: 350,
    paddingBottom: 5
  },
}));

const MatchCard = (props) => {
  const [modalShow, setModalShow] = useState(false)
  
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const showModal = () => {
    setModalShow(true);
    setAnchorEl(null);
  }

  const handleModal = (handle) => {
    setModalShow(handle);
  }

  console.log("-----")
  console.log(props.cv.resume.features)

  return (
    <>
      <Card className={classes.root}>
      <CardHeader
        avatar={<PersonIcon style={{ fontSize: 60, color: '#29479a' }} />}
        action={
          <IconButton aria-label="settings">
            <MoreVertIcon
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleClick}
            />
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={showModal}>Profile</MenuItem>
            </Menu>
          </IconButton>
        }
      />
      <CardHeader 
        title={props.cv.fullname} 
        subheader={props.cv.title} />
      <CardContent>
        <Typography variant="body2" color="textSecondary" component="div">
          {props.cv.resume.features} 
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
        <CustomBtn  
          type='secondary'
          width='20%' 
          fntSize='15px' 
          colorwhite={false} 
          txt='connect'
          onClick={null}/>
      </CardActions>
    </Card>
    <MydModalWithGrid talent={props.cv} handle={handleModal} show={modalShow}/>
    </>
  )
}

export default MatchCard;